(function ($) {
    const behavior = 'polyu_theme.footer-configuration';
    Drupal.behaviors[behavior] = {
        attach: (context, settings) => {
        
        }
        
    };
    
    $(function () {
        window.openAIChatbot = (width, height) => {
            const isPopupOpen = sessionStorage.getItem('aiChatbotIsOpen');
            // Check if the AI-Chatbot window is already open
            if (!isPopupOpen || (window.aiChatbotWindow && typeof window.aiChatbotWindow.closed !== 'undefined' && window.aiChatbotWindow.closed)) {
                // Open a new AI-Chatbot window with a random name
                const windowName = 'AI-Chatbot';
                window.aiChatbotWindow = window.open("https://arstudychatbot.polyu.edu.hk/", windowName, `width=${width}vw,height=${height}vh`);
                // Set the sessionStorage flag to indicate that the pop-up is open
                sessionStorage.setItem('aiChatbotIsOpen', 'true');
                
                // Attach an event listener to reset the sessionStorage flag when the window is closed
                window.aiChatbotWindow.addEventListener('beforeunload', () => {
                    sessionStorage.removeItem('aiChatbotIsOpen');
                });
            } else {
                // Focus on the existing AI-Chatbot window if it's already open
                window.aiChatbotWindow.focus();
            }
        };
        // Clear sessionStorage when navigating to another page
        $(window).on('beforeunload', () => {
            sessionStorage.removeItem('aiChatbotIsOpen');
        });
        
        window.scrollToTop = () => {
            $("html, body").animate({
                scrollTop: 0
            }, "slow");
            return false;
        };
    });
})(jQuery);
